import React, {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import image1 from "../../../../assets/images/Blog36/image1 what is neutral.png";
import image2 from "../../../../assets/images/Blog36/image2 the dot plot did move.png";
import image7 from "../../../../assets/images/Blog36/image7 sector performers.png";
import image12 from "../../../../assets/images/Blog36/image12 non-profit tech worries.png";
import image13 from "../../../../assets/images/Blog36/image13 earnings still on a tear.png";
import image11 from "../../../../assets/images/Blog36/image11 china tech highs.png";
import image17 from "../../../../assets/images/Blog36/image17 US10Y worries.png";
import image16 from "../../../../assets/images/Blog36/image16 US30Y concerns.png";
import image3 from "../../../../assets/images/Blog36/image3 nas100 gamma flip.png";
import image4 from "../../../../assets/images/Blog36/image4 nas100 exposure by strike.png";
import image9 from "../../../../assets/images/Blog36/image9 nas100 divergence.png";
import image15 from "../../../../assets/images/Blog36/image15 dollar v global cuts.png";
import image5 from "../../../../assets/images/Blog36/image5 SPX gamma flip.png";
import image6 from "../../../../assets/images/Blog36/image6 SPX gamma exposure.png";
import image34 from "../../../../assets/images/Blog36/image34 hawk talk.png";
import image19 from "../../../../assets/images/Blog36/image19 gold overbought underowned (1).png";
import image23 from "../../../../assets/images/Blog36/image23 gold new ATH higher degree.png";
import image26 from "../../../../assets/images/Blog36/image26 silver still catching up gold.png";
import image18 from "../../../../assets/images/Blog36/image18 volatility too low_.png";
import image35 from "../../../../assets/images/Blog36/image35 core pce.png";
import image33 from "../../../../assets/images/Blog36/image33 US data gdp.png";
import BlogImagePopper from "./BlogImageLarge";

const Blog36 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – September 29th, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedText">Dot Plots, Gamma Flows, and Precious Metals in Overdrive</p>
        <p>
          Markets closed September steady on the surface but fragile underneath. The Fed’s latest dot plot pushed expectations higher-for-longer, equities remain pinned by gamma flows, and gold and
          silver surged into overdrive. Beneath the calm, divergences in breadth, volatility suppression, and Treasury market stress suggest Q4 may not remain so quiet.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Calm Indices, Fragile Internals</p>
              <p>
                The Fed’s <span className="highlightedText">dot plot revisions</span> confirmed what traders feared — policy makers are leaning hawkish, forcing markets to reconsider the “neutral”
                rate. Higher-for-longer has now been priced more firmly into expectations.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image1}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image1)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image2}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image2)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Equities continue their grind higher, but participation is narrowing. Mega-cap tech remains the driver, while non-profitable growth names weaken. Earnings resilience keeps the bullish
                case alive, but leadership is thin.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image7}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image7)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image12}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image12)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image13}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image13)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Globally, China’s tech rally offered support, yet U.S. Treasuries sent a different signal. Stress at the long end of the curve (10Y and 30Y) hints that bond investors aren’t fully
                convinced by the soft-landing narrative.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image11}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image11)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image17}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image17)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image16}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image16)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Fed Hawkishness, China Momentum, Treasury Stress</p>
              <p>
                The
                <span className="highlightedText"> September Fed meeting</span> delivered a clear message: the path to easing is shallower, and the definition of neutral has shifted upward. This
                structural adjustment means traders need to respect policy stickiness.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image2}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image2)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Meanwhile, <span className="highlightedText">China’s tech sector</span> has regained momentum, breaking to multi-month highs. Policy tailwinds and investor flows into relative value
                plays supported the breakout.
              </p>
              <p>
                But U.S. Treasuries tell another story. The<span className="highlightedText"> 10Y and 30Y yields</span> both highlighted ongoing supply-demand imbalances, weighing on investor
                sentiment.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image17}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image17)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image16}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image16)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Gamma, Divergences & Commodities</p>
              <p className="highlightedText">NASDAQ 100 – Gamma Flows & Divergences</p>
              <p>
                The NAS100 remains pinned near its gamma flip level. Options positioning shows heavy exposure at clustered strikes, raising the risk of outsized moves once hedging flows shift.
                Divergences between price and momentum caution against complacency.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image3}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image3)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image4}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image4)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image9}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image9)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p className="highlightedText">S&P 500 – Dealer Hedging Dominates</p>
              <p>SPX intraday moves remain almost entirely dictated by dealer gamma flows. Until volatility reprices higher, expect chop around these mechanical levels.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image5}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image5)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p className="highlightedText">Dollar & Options Positioning</p>
              <p>The dollar trades tactically against global rate cut expectations. Options data shows traders positioning for asymmetric payoffs.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image15}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image15)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p className="highlightedText">Gold & Silver – Overdrive Mode</p>
              <p>
                Gold has broken to <span className="highlightedText">new all-time highs.</span> While technically overbought, sentiment suggests it remains underowned — fuelling continued inflows.
                Silver is catching up rapidly, but now risks entering a blowoff zone.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image19}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image19)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image23}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image23)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image26}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image26)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p className="highlightedText">Volatility – Too Quiet</p>
              <p>Volatility indices remain unusually subdued despite macro risks. Traders should treat the calm as fragile — historically, suppressed vol often precedes explosive re-pricing.</p>
              <div className="relatedImg">
                <img
                  src={image18}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image18)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Hawkish Fed, Strong Data, Metals Surge</p>
              <p className="highlightedText">Inflation & Growth: A Mixed Pulse</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Core PCE remained firm, keeping the Fed cautious.</p>
                </li>
                <li className="themesPointer">
                  <p>
                    GDP Q2 data pointed to resilience by the consumer, and Atlanta GDPNow surged to 3.9% for Q3, but cracks are forming at the margin with Michigan sentiment dropping and concerns
                    about jobs growing.
                  </p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image35}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image35)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image33}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image33)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p className="highlightedText">Fed Speak: Hawkish Tone Dominated</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Policymakers reinforced higher-for-longer.</p>
                </li>
                <li className="themesPointer">
                  <p>Bond Markets priced fewer cuts and stickier inflation risks.</p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image34}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image34)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p className="highlightedText">Earnings: Still Resilient</p>
              <p>Corporate earnings momentum continues, supporting valuations despite policy headwinds. Buy the dip saved the September rally from fading</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image13}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image13)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p className="highlightedText">Metals: Relentless Bid</p>
              <p>Gold and silver rallied hard, extending their multi-week streaks.</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead – Macro Data Cluster and NFP Spotlight</p>

              <p className="highlightedText">Monday 29th Sep 2025</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>U.S. Treasury Bill Auctions</p>
                </li>
                <li className="themesPointer">
                  <p>ECB policymakers speaking</p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday 30th Sep 2025</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>U.S. Consumer Confidence (key sentiment gauge)</p>
                </li>
                <li className="themesPointer">
                  <p>U.S. Housing Data</p>
                </li>
                <li className="themesPointer">
                  <p>Fed speakers providing post-FOMC guidance</p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday 1st Oct 2025</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Global PMIs & ISM Manufacturing (growth pulse checks)</p>
                </li>

                <li className="themesPointer">
                  <p>U.S. 10Y Treasury Auction (long-end stress in focus)</p>
                </li>
              </ul>

              <p className="highlightedText">Thursday 2nd Oct 2025</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>U.S. Jobless Claims</p>
                </li>

                <li className="themesPointer">
                  <p>ISM Services PMI</p>
                </li>
                <li className="themesPointer">
                  <p>ECB Minutes (cross-checking divergence with Fed stance)</p>
                </li>
              </ul>

              <p className="highlightedText">Friday 3rd Oct 2025</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p className="highlightedText">Nonfarm Payrolls (NFP), U.S. Unemployment Rate, and Average Hourly Earnings</p>
                </li>

                <li className="themesPointer">
                  <p>
                    The most important release of the week, capable of
                    <span className="highlightedText"> resetting Fed expectations into Q4</span>
                  </p>
                </li>
              </ul>

              <div className="relatedImg">
                <img
                  src={image35}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image35)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p className="highlightedText">Big Picture:</p>
              <p>
                Markets remain pinned by gamma levels, and volatility is suppressed. However, this week’s <span className="highlightedText"> cluster of macro releases plus Friday’s NFP</span> creates
                headline risk and potential intraday swings. Traders should maintain tight stops and disciplined levels. Friday in particular could trigger a volatility regime shift.
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Fragile Calm, Volatility on the Horizon</p>
              <p>Markets are holding together, but the calm is fragile. Beneath the surface, risks are stacking up:</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span> Earnings support valuations, but gamma-driven flows are masking thinning breadth.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Rates:</span> The U.S. 10Y and 30Y stress highlight unresolved fragility in the bond market.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver:</span> Strong momentum persists, but silver in particular risks blowoff behaviour
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Volatility:</span> Still at compressed levels, leaving traders exposed to sudden shocks.
                  </p>
                </li>
              </ul>
              <p className="highlightedText">Our stance:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Respect gamma flip zones in SPX and NASDAQ; chasing extended rallies is dangerous.</p>
                </li>
                <li className="themesPointer">
                  <p>Stay tactical and defensive, tighten stops on equity exposure.</p>
                </li>
                <li className="themesPointer">
                  <p>Use gold/silver strength strategically; partial profit-taking is prudent before blowoff phases.</p>
                </li>
                <li className="themesPointer">
                  <p>
                    Position ahead of NFP for a potential <span className="highlightedText"> volatility regime shift.</span>
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image19}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image19)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image18}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image18)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1bZZ0x28tTECGornpXJ4RJ91ynOkOcFyfA-RqGsw3kic/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog36;
